import { render, staticRenderFns } from "./AutomatedPOOverview.vue?vue&type=template&id=a617124a&scoped=true"
import script from "./AutomatedPOOverview.vue?vue&type=script&lang=js"
export * from "./AutomatedPOOverview.vue?vue&type=script&lang=js"
import style0 from "./AutomatedPOOverview.vue?vue&type=style&index=0&id=a617124a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a617124a",
  null
  
)

export default component.exports